import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import imagen from "../../assets/images/imagen_login.jpg";
import Logo from "../../assets/images/logo.png";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Función para manejar el inicio de sesión
  const handleLogin = () => {
    // Verificación de credenciales
    if (email === "admin" && password === "admin") {
      navigate("/empresas");
    } else if (email === "user" && password === "user") {
      navigate("/user");
    } else {
      alert("Credenciales incorrectas");
    }
  };

  return (
    <div className="flex flex-col-reverse md:flex-row h-screen items-center justify-center">
      {/* Sección Izquierda - Formulario */}
      <div className="md:w-1/2 flex items-center justify-center p-8">
        <div className="max-w-md w-full justify-center items-center">
          <div className="flex w-full items-center justify-left mb-[20px]">
            <img
              src={Logo}
              alt="AI handshake"
              className="w-[68px] object-cover rounded-xl mr-1"
            />
            <h1 className="text-[40px] text-textTitle font-semibold">PIXU</h1>
          </div>

          <h2 className="text-textTitle text-2xl font-semibold mb-2">
            Bienvenido de nuevo 👋
          </h2>
          <p className="text-textTipic mb-6">
            Inicia sesión para comenzar a gestionar tus proyectos.
          </p>

          <label className="text-textLabel block text-sm font-medium">
            Email
          </label>
          <input
            type="text"
            placeholder="Example@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full text-textTipic p-2 border rounded mb-4"
          />

          <label className="text-textLabel block text-sm font-medium">
            Contraseña
          </label>
          <input
            type="password"
            placeholder="At least 8 characters"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full text-textTipic p-2 border rounded mb-4"
          />

          <a href="#" className="text-sm text-textPrimary">
            ¿Olvidó su contraseña?
          </a>
          <button
            onClick={handleLogin}
            className="w-full bg-bgSecundary text-white py-2 rounded mt-4"
          >
            Sign in
          </button>

          <p className="text-xs text-gray-400 text-center mt-4">
            © 2023 ALL RIGHTS RESERVED
          </p>
        </div>
      </div>

      {/* Sección Derecha - Imagen (oculta en pantallas pequeñas) */}
      <div className="hidden md:flex md:w-1/2 items-center justify-center p-16 h-[100%]">
        <div className="relative w-full h-[100%] flex items-center justify-center">
          <img
            src={imagen}
            alt="AI handshake"
            className="w-full h-full object-cover rounded-xl"
          />
          <h3 className="absolute top-[60px] text-[48px] font-medium text-white">
            La{" "}
            <span className="text-[72px] text-textSecundary font-semibold">
              IA
            </span>{" "}
            de nuestro lado
          </h3>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
